import shortid from "shortid";
import { formatDate } from "../../../../utils";
import {
  calculaSubtotalParaChave,
  calculoDesconto,
  totalItensLista,
} from "../addOrcamentos";
import { addDays } from "date-fns";

export class Orcamento {
  dataEmissao = null;
  numeroDocumento = null;
  serieDocumento = null;
  operacaoFiscalId = null;
  pessoaVendedorId = null;
  pessoaClienteId = null;
  pessoaProficionalId = null;
  condicaoPagamentoId = null;
  meioPagamentoId = null;
  desconto = null;
  acrescimo = null;
  despesas = null;
  informacaoAdicional = null;
  itens = null;
  orcamentoEnderecoCliente = null;
  status = null;
  descontoItem = null;
  despesasItem = null;
  dataVencimento = null;

  constructor(orcamento, id) {
    if (id) {
      this.operacaoFiscalId = orcamento.operacaoFiscalId;
      this.numeroDocumento = orcamento.numeroDocumento;
      this.serieDocumento = orcamento.serieDocumento;
      this.pessoaVendedorId = orcamento.pessoaVendedorId;
      this.pessoaClienteId = orcamento.pessoaClienteId;
      this.pessoaProficionalId = orcamento.pessoaProficionalId;
      this.orcamentoEnderecoCliente = orcamento.orcamentoEnderecoCliente;
      this.informacaoAdicional = orcamento.informacaoAdicional;
      this.itens = orcamento.itens?.length
        ? orcamento.itens.map((item) => new OrcamentoItens(item))
        : [];
      this.condicaoPagamentoId = orcamento.condicaoPagamentoId;
      this.meioPagamentoId = orcamento.meioPagamentoId;
      this.status = orcamento.status;
      this.descontoItem = orcamento.descontoItem || false;
      this.despesasItem = orcamento.despesasItem || false;
    }
    this.dataEmissao = orcamento.dataEmissao;
    this.desconto = orcamento.desconto;
    this.acrescimo = orcamento.acrescimo;
    this.despesas = orcamento.despesas;
    this.dataVencimento = orcamento.dataVencimento;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeDate(name, date) {
    this[name] = date != "Invalid Date" ? formatDate.toSend(date) : undefined;
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
    if (name === "operacaoFiscalId") {
      this.setOperacaoFiscal(value);
    }
  }

  setChangeItens(produtos) {
    this.desconto = calculaSubtotalParaChave(produtos, "", "desconto");
    this.despesas = calculaSubtotalParaChave(produtos, "", "despesas");
    this.itens = produtos?.length
      ? produtos.map((produto) => new OrcamentoItens(produto))
      : [];
    this.totalItens = parseFloat(totalItensLista(produtos)?.toFixed(2));
    this.totalOrcamento =
      parseFloat(this.totalItens || 0) -
      parseFloat(this.desconto || 0) +
      parseFloat(this.acrescimo || 0) +
      parseFloat(this.despesas || 0);
    this.descontoPorcentagem = calculoDesconto(produtos, this, false);
  }

  setEnderecoCliente(enderecoAlterado, enderecoCliente) {
    if (this.pessoaClienteId) {
      const endereco = enderecoAlterado || enderecoCliente;
      if (endereco) {
        this.orcamentoEnderecoCliente = {
          ...endereco,
          pessoaId: this.pessoaClienteId,
        };
        return;
      }
    }
    this.orcamentoEnderecoCliente = null;
  }

  setOperacaoFiscal(operacaoFiscal) {
    this.operacaoFiscalId = operacaoFiscal?.id;
    this.serieDocumento = operacaoFiscal?.serieDocumento;
    this.modeloDocumento = operacaoFiscal?.modeloDocumento;
  }

  setVendedorObrigatorioPermissao(permissao) {
    this.vendedorObrigatorio = permissao;
  }

  setDescontoPorcentagem(listaPedidosProdutos, porcentagem = false) {
    this[porcentagem ? "descontoPorcentagem" : "desconto"] = calculoDesconto(
      listaPedidosProdutos,
      this,
      false
    );
  }

  setConfiguracoes(configuracoes) {
    this.descontoItem = configuracoes?.descontoVendaItem;
    this.despesasItem = configuracoes?.despesaVendaItem;
    if (configuracoes?.diasVencimentoOrcamento) {
      const dataVencimento = addDays(
        new Date(),
        configuracoes?.diasVencimentoOrcamento
      );
      this.dataVencimento = dataVencimento;
    }
  }
}

class OrcamentoItens {
  produtoId = null;
  unidade = null;
  quantidade = null;
  desconto = null;
  despesas = null;
  codigo = null;
  valorUnitario = null;
  ncm = null;
  tributosIcmsOrigem = null;
  origemKitId = null;
  precoCusto = null;
  ordemCompra = null;
  numeroItem = null;
  
  constructor(item) {
    this.id = item.id ? item.id : shortid.generate();
    this.produtoId = item.produtoId;
    this.unidade = item.unidade;
    this.quantidade = item.quantidade;
    this.desconto = item.desconto;
    this.despesas = item.despesas;
    this.codigo = item.codigo;
    this.valorUnitario = item.valorUnitario;
    this.ncm = item.ncm;
    this.tributosIcmsOrigem = item.tributosIcmsOrigem;
    this.origemKitId = item.origemKitId;
    this.precoCusto = item.precoCusto;
    this.ordemCompra = item.ordemCompra;
    this.numeroItem = item.numeroItem;
  }

  setInputAttribute(name, value) {
    this[name] = value;
  }
}
